import React from 'react';
import Header from './components/Header';
import IntroSection from './components/IntroSection';
import DownloadSection from './components/DownloadSection';
import InstallGuideSection from './components/InstallGuideSection';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <IntroSection />
        <InstallGuideSection />
        <DownloadSection />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
